class DetailsModal extends HTMLElement {
  connectedCallback() {
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.modal = this.querySelector('[role="dialog"]');
    this.headerElement = this.closest('header');
    this.events = new AbortController();
    const options = { signal: this.events.signal };
    this.modal.inert = true;
    this.summaryToggle.addEventListener('click', event => {
      event.preventDefault();
      this.isOpen() ? this.close() : this.open();
    }, options);
    this.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || event.defaultPrevented || !this.isOpen()) return;
      event.preventDefault();
      this.close();
    }, options);
    this.querySelector('.search-modal__close-button').addEventListener('click', () => this.close(), options);
    this.querySelector('.modal-overlay').addEventListener('click', () => this.close(), options);
  }

  disconnectedCallback() {
    this.close(false);
    this.events.abort();
  }

  isOpen() {
    return this.detailsContainer.open;
  }

  open() {
    this.detailsContainer.open = true;
    this.modal.inert = false;
    this.headerElement?.classList.add('search-is-open');
    this.wasScrollLocked = document.body.classList.contains('overflow-hidden');
    document.body.classList.add('overflow-hidden');
    this.releaseBackground = inertOutside(this.modal);
    trapFocus(this.modal, this.querySelector('input[type="search"]'));
  }

  close(focusToggle = true) {
    if (!this.isOpen()) return;
    this.querySelector('predictive-search')?.close();
    this.releaseBackground?.();
    this.modal.inert = true;
    this.detailsContainer.open = false;
    if (!this.wasScrollLocked) document.body.classList.remove('overflow-hidden');
    this.headerElement?.classList.remove('search-is-open');
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
  }
}

customElements.define('details-modal', DetailsModal);
